/** Client-side record that the user accepted the Presale legal docs. */

export const PRESALE_RISK_URL = 'https://presale.incpt.fi/risk-disclosure/';
export const PRESALE_AGREEMENT_URL = 'https://presale.incpt.fi/presale-agreement/';
export const PRESALE_PRIVACY_URL = 'https://presale.incpt.fi/privacy/';

const KEY = 'incpt_presale_legal_v2';

export type PresaleLegalAccepted = {
  /** Combined Presale Terms + Risk Disclosure. */
  terms: boolean;
  /** Not a U.S. Person / sanctioned / restricted jurisdiction. */
  jurisdiction: boolean;
};

export function loadPresaleLegal(): PresaleLegalAccepted {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { terms: false, jurisdiction: false };
    const parsed = JSON.parse(raw) as Partial<PresaleLegalAccepted>;
    return { terms: !!parsed.terms, jurisdiction: !!parsed.jurisdiction };
  } catch {
    return { terms: false, jurisdiction: false };
  }
}

export function savePresaleLegal(next: PresaleLegalAccepted): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* private mode / quota */
  }
}

export function openPresaleLegal(url: string): void {
  const wa = window.Telegram?.WebApp;
  if (wa?.openLink) wa.openLink(url);
  else window.open(url, '_blank', 'noopener,noreferrer');
}
